import React from 'react';

import { Box } from '@styleseat/ui';
import {
  Stack, BodyText, Button,
} from '../../../../../ui';
import FireStarsGradient from '../../../../../ui/Icons/FireStarsGradient';

import Title from '../../Title';
import ProgressBar from '../../ProgressBar';

type EarningProps = {
  maxValue?: number;
  currentValue: number;
  daysLeft: number;
  cta: {
    text: string;
    onClick: () => void;
  };
};
const Earning: React.FC<EarningProps> = ({
  maxValue = 6,
  currentValue,
  daysLeft,
  cta,
}) => (
  <Stack justifyContent="center" alignItems="center">
    <FireStarsGradient />
    <Title modeText="EARN A" />
    <BodyText appearance="small" textAlign="center" testID="search-boost-earning-text">
      Book {maxValue - currentValue} appointments in the next {daysLeft} days,
      and we’ll push your profile to the top of client searches in your area.
    </BodyText>
    <ProgressBar maxValue={maxValue} currentValue={currentValue} />
    <Box paddingTop={20}>
      <Button
        size="medium"
        appearance="primary"
        onClick={cta.onClick}
        style={{
          borderRadius: 4,
          textTransform: 'capitalize',
        }}
      >
        {cta.text}
      </Button>
    </Box>
  </Stack>
);

export default Earning;
